import axios from "axios";
import actions from "./actions";
import { getFilterUrlPart } from "../../lib/utils";
import _ from "lodash";

const getDomainFromQuestion = (question, configuration) => {
  var domain = "";

  if (question === "cultureOverall") {
    domain = "cultureOverall";
  } else if (question.startsWith("le")) {
    domain = "le";
  } else if (question.startsWith("psy")) {
    domain = "ll";
  } else if (question.startsWith("eeclm")) {
    domain = "ee";
  } else if (question.startsWith("eeme")) {
    domain = "me";
  } else if (question.startsWith("go")) {
    domain = "go";
  } else if (question.startsWith("jobunc")) {
    domain = "ju";
  } else if (question.startsWith("itl")) {
    domain = "il";
  } else if (question.startsWith("adv")) {
    domain = "ad";
  } else if (question.startsWith("ptdm")) {
    domain = "dm";
  } else if (question.startsWith("wl")) {
    domain = "wk";
  } else if (
    question == "resolve" ||
    question == "spkupclt" ||
    question == "easyask" ||
    question == "peopleteam" ||
    question == "diffcoll" ||
    question == "comdelay" ||
    question == "comdelayotherset"
  ) {
    domain = "tm";
  } else if (
    question == "safeacted" ||
    question == "erhndlapp" ||
    question == "feedback" ||
    question == "cultlearn" ||
    question == "feelsafe" ||
    question == "diffdiscuss" ||
    question == "valueshared"
  ) {
    domain = "sc";
  } else if (
    question == "skipmeal" ||
    question == "poormeal" ||
    question == "nobreaks" ||
    question == "late4home" ||
    question == "difsleeping" ||
    question == "sleptlt5hours" ||
    question == "changplan" ||
    question == "techfrust"
  ) {
    domain = "wlb";
  } else if (
    question == "usestrengths" ||
    question == "thriving" ||
    question == "meaningfuldif" ||
    question == "forward"
  ) {
    domain = "th";
  } else if (
    question == "bounceback" ||
    question == "adaptnoinfluence" ||
    question == "moodrecovers" ||
    question == "regainoutlook"
  ) {
    domain = "rc";
  } else if (question == "phys_safety") {
    domain = "ps";
  } else if (configuration) {

    const config_question = _.find(configuration.questions, c => c.question === question);
    if (config_question)
      domain = config_question.domain_code;
  }
  
  return domain;
};

const fetchKeyDrivers = (id, options) => (dispatch, getState) => {
  dispatch(actions.fetchKeyDriversStart());
  const {
    units,
    token,
    actualSurvey,
    optimized,
    surveyQuestions,
    comparativeDatasets,
    comparativeUnitMappings,
    comparativePositionMappings,
    survey,
    version,
    system,
    configuration,
  } = options;
  const requestBody = { comparativeDatasets, comparativeUnitMappings, comparativePositionMappings };
  const unitsParam = units
    ? `&units='${_.map(units, function (unit) {
        return encodeURIComponent(unit); //.replace(/&/g, "%26");
      }).join(`','`)}'`
    : "";
  let columns = [];
  const filterParams = getFilterUrlPart(getState().filters);

  const keyDrivers = configuration && configuration.key_drivers && configuration.key_drivers.rows;
  if (keyDrivers) {
    const columnSet = new Set();
    if (keyDrivers.landscape) {
      keyDrivers.landscape.map((row) => row.map((column) => columnSet.add(column)));
    }
    if (keyDrivers.portrait) {
      keyDrivers.portrait.map((row) => row.map((column) => columnSet.add(column)));
    }
    columnSet.forEach((column) => columns.push(column));
  } else if (actualSurvey === "AMITA" || actualSurvey === "AMITA_v2.0.0") {
    // AMITA
    columns = [
      "leinput",
      "lefixdefct",
      "psyuseflfb",
      "psyposfb",
      "eeclmburn",
      "spkupclt",
      "diffcoll",
      "comdelay",
      "cultlearn",
      "feelsafe",
    ];
  } else if (actualSurvey === "VALLEY_2020") {
    columns = [
      "leinput",
      "lefixdefct",
      "psyposfb",
      "eeclmburn",
      "eemeburn",
      "spkupclt",
      "diffcoll",
      "comdelay",
      "cultlearn",
      "feelsafe",
    ];
  } else if (actualSurvey === "SUTTER_Pulse") {
    // SUTTER_Pulse
    columns = [
      "leinput",
      "lefixdefct",
      "psyposfb",
      "eemeburn",
      "spkupclt",
      "comdelay",
      "cultlearn",
      "feelsafe",
      "phys_safety",
    ];
  } else if (actualSurvey === "NonClinical") {
    columns = [
      "leinput",
      "lefixdefct",
      "psyposfb",
      "eeclmburn",
      "diffcoll",
      "comdelay",
      "cultlearn",
      "nobreaks",
      "goachieve",
      "itlthnklv",
    ];
  } else if (actualSurvey === "SUTTER_Pulse_PhysicianAcute") {
    // SUTTER_Pulse_PhysicianAcute
    columns = [
      "comdelay",
      "feelsafe",
      "ptdmmywork",
      "goachieve",
      "spkupclt",
      "psyposfb",
      "cultlearn",
      "lefixdefct",
      "leinput",
    ];
  } else if (actualSurvey === "SUTTER_Pulse_PhysicianAmb") {
    // SUTTER_Pulse_PhysicianAmb
    columns = ["spkupclt", "comdelay", "cultlearn", "feelsafe"];
  } else if (actualSurvey === "ASC_SOPS_2023") {
    // ASC_SOPS_2023
    columns = [
      "doesnt_seem_right",
      "blame_emphasized",
      "rushed_care_patients",
      "actively_improve_ps",
      "good_communicate_info",
      "mgnt_adeq_resources",
      "staff_treated_fairly",
      "handle_workload",
      "others_help_out",
      "work_together_team"
    ];
  } else if (survey.indexOf("SCORE") > -1) {
    if (system === "NYU" && version.major > 1) {
      // NYU
      columns = [
        "leinput",
        "lefixdefct",
        "psyposfb",
        "eeclmburn",
        "spkupclt",
        "diffcoll",
        "comdelay",
        "cultlearn",
        "feelsafe",
        "ptdmmywork",
      ];
    } else {
      // SCORE
      columns = [
        "lefixdefct",
        "psyposfb",
        "eeclmburn",
        "diffcoll",
        "comdelay",
        "cultlearn",
        "feelsafe",
        "nobreaks",
        "goachieve",
        "itlthnklv",
      ];
    }
  } else {
    if (survey.indexOf("Pulse") < 0) {
      if (actualSurvey === "VIZ_BNCHMRK_Pulse_2022") {
        // VIZ_BNCHMRK_Pulse_2022
        columns = [
          "leinput",
          "lefixdefct",
          "psyposfb",
          "eeclmburn",
          "eemeevents",
          "eemeburn",
          "eemeexhausted",
          "resolve",
          "spkupclt",
          "diffcoll",
          "comdelay",
          "comdelayotherset",
          "safeacted",
          "erhndlapp",
          "feelsafe",
          "diffdiscuss",
          "valueshared",
          "usestrengths",
          "meaningfuldif",
        ];
      } else {
        // SCOR
        columns = [
          "leinput",
          "lefixdefct",
          "psyposfb",
          "eeclmburn",
          "eemeburn",
          "spkupclt",
          "diffcoll",
          "comdelay",
          "cultlearn",
          "feelsafe",
          "nobreaks",
        ];
      }
    } else {
      // SCOR_Pulse
      columns = [
        "leinput",
        "lefixdefct",
        "psyposfb",
        "eeclmburn",
        "spkupclt",
        "diffcoll",
        "comdelay",
        "cultlearn",
        "feelsafe",
        "nobreaks",
      ];
    }
  }
  function retryOnFail(task, attempt) {
    if (!attempt) {
      attempt = 1;
    }
    return task().catch((err) => {
      if (attempt < 3) {
        attempt += 1;
        return retryOnFail(task, attempt);
      } else {
        dispatch(actions.fetchKeyDriversError(err));
      }
    });
  }
  function getKeyDriver(url, column) {
    return retryOnFail(function () {
      return axios.post(url, requestBody).then((res) => {
        return Promise.resolve({
          column,
          data: res.data,
        });
      });
    });
  }
  const promises = [];
  for (let i = 0; i < columns.length; i++) {
    // if (_.includes(_.map(surveyQuestions, "column"), columns[i])) { // UNCOMMENT ME
    promises.push(
      getKeyDriver(
        `/api/survey/${id}/bar/domain/${getDomainFromQuestion(columns[i], configuration)}/question/${
          columns[i]
        }/by/facility/sort/group_percent/desc?showAllColors=true&token=${token}&version=${actualSurvey}&optimized=${optimized}${unitsParam}${filterParams}`,
        columns[i]
      )
    );
    // }
  }
  Promise.all(promises).then((results) => {
    const keyDrivers = {};
    for (let i = 0; i < results.length; i++) {
      if (results[i]) {
        keyDrivers[results[i].column] = results[i].data;
      }
    }
    dispatch(actions.fetchKeyDrivers(keyDrivers));
  });
};

const clearProgress = () => (dispatch, getState) => {
  dispatch(actions.fetchKeyDriversStart());
};

export default {
  fetchKeyDrivers,
  clearProgress,
};



// WEBPACK FOOTER //
// ./src/redux/keyDrivers/operations.js